import { useState } from 'react';
import { connect } from 'react-redux';
import { array } from 'fp-ts';
import { TooltippedIconButton } from '@mews-commander/ui';
import { Button, IconName } from '@optimus-web/core';
import { ApplicationState, Device } from '@mews-commander/types';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { getKeyCutters } from '@mews-commander/legacy-entities/src/reducers/keyCutters';
import KeyCutterDialog from './KeyCutterDialog';

interface OwnProps {
    reservationIds: string[];
    initKeyCount?: number;
    textKey?: Mews.TextKey;
}
interface StateProps {
    keyCutters: Device[];
}
type Props = OwnProps & StateProps;

const KeyCutterButton = ({ reservationIds, keyCutters, initKeyCount, textKey }: Props) => {
    const [activeDialog, setActiveDialog] = useState<boolean>(false);

    if (array.isEmpty(keyCutters)) return null;

    const handleClick = () => setActiveDialog(true);
    const handleClose = () => setActiveDialog(false);

    const buttonProps = {
        icon: IconName.Key,
        onClick: handleClick,
        variant: 'tertiary' as const,
        size: 'small' as const,
        'data-test-id': DataTestId.KeyCutterButton,
        type: 'button' as const,
    };
    return (
        <>
            {textKey ? (
                <Button {...buttonProps} type="submit">
                    <LocalizedText textKey={textKey} />
                </Button>
            ) : (
                <TooltippedIconButton tooltip={<LocalizedText textKey={TextKey.CreateKeys} />} {...buttonProps} />
            )}
            <KeyCutterDialog
                active={activeDialog}
                closeDialog={handleClose}
                reservationIds={reservationIds}
                onSuccess={handleClose}
                initKeyCount={initKeyCount}
            />
        </>
    );
};

export default connect<StateProps, {}, OwnProps, ApplicationState>((state) => ({
    keyCutters: getKeyCutters(state),
}))(KeyCutterButton);
